import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=64300d20&scoped=true&"
import script from "./CatalogPage.vue?vue&type=script&lang=js&"
export * from "./CatalogPage.vue?vue&type=script&lang=js&"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&id=64300d20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64300d20",
  null
  
)

export default component.exports